import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-digitize-attendance-exams-homework-using-lms',
  templateUrl: './digitize-attendance-exams-homework-using-lms.component.html',
  styleUrls: ['./digitize-attendance-exams-homework-using-lms.component.scss']
})
export class DigitizeAttendanceExamsHomeworkUsingLmsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Digitize Attendance, Exams & Homework with LMS | VIRSA');
    this.metaService.updateTag({
      name: 'description',
      content: 'Learn how schools and educational institutions can digitize attendance, exams, homework, assessments and student performance tracking using the VIRSA Learning Management System.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'digitize attendance exams and homework, LMS for attendance management, LMS for online exams, digital homework management, school LMS, Learning Management System for schools, digital attendance system for schools, online exam management system, homework management system, VIRSA LMS, AI-powered LMS for schools, student attendance tracking, digital assessment system, online homework system, school examination management, student performance tracking, digital learning management system, school ERP and LMS, education LMS platform, AI LMS for education, digital classroom management'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
